export const SERIES_STATE_CHANGE_SUBTYPE = 'seriesStateChange';
export const SERIES_STATE_CHANGE_LABEL = 'Cambio de estado de serie';
export const SERIES_STATE_CHANGE_ACTION_LABEL = 'Cambiar estado';

const getTransactionTypeId = transaction =>
	transaction?.transactionTypeId ??
	transaction?.transaction_type_id ??
	transaction?.typeTransaction;

const parseProps = props => {
	if (!props || typeof props === 'object') return props || {};

	try {
		return JSON.parse(props);
	} catch (_error) {
		return {};
	}
};

export const isSeriesStateChangeTransaction = transaction =>
	Number(getTransactionTypeId(transaction)) === 28 &&
	parseProps(transaction?.props).subtype === SERIES_STATE_CHANGE_SUBTYPE;

export const getTransactionPresentation = transaction => {
	const isSeriesStateChange = isSeriesStateChangeTransaction(transaction);

	return {
		isSeriesStateChange,
		transactionTypeName: isSeriesStateChange
			? SERIES_STATE_CHANGE_LABEL
			: (transaction?.transactionTypeName ??
				transaction?.transaction_type_name),
		methodName: isSeriesStateChange
			? SERIES_STATE_CHANGE_LABEL
			: (transaction?.methodName ?? transaction?.method_name),
		actionLabel: isSeriesStateChange
			? SERIES_STATE_CHANGE_ACTION_LABEL
			: (transaction?.actionLabel ??
				transaction?.action_label ??
				transaction?.action),
	};
};

export const applyTransactionPresentation = transaction => {
	if (!isSeriesStateChangeTransaction(transaction)) return transaction;

	const presentationFields = {
		transactionTypeName: SERIES_STATE_CHANGE_LABEL,
		transaction_type_name: SERIES_STATE_CHANGE_LABEL,
		methodName: SERIES_STATE_CHANGE_LABEL,
		method_name: SERIES_STATE_CHANGE_LABEL,
		actionLabel: SERIES_STATE_CHANGE_ACTION_LABEL,
		action_label: SERIES_STATE_CHANGE_ACTION_LABEL,
		action: SERIES_STATE_CHANGE_ACTION_LABEL,
	};
	const updates = Object.entries(presentationFields).reduce(
		(result, [key, value]) =>
			Object.prototype.hasOwnProperty.call(transaction, key) &&
			transaction[key] !== value
				? { ...result, [key]: value }
				: result,
		{},
	);

	return Object.keys(updates).length
		? { ...transaction, ...updates }
		: transaction;
};

export const applyTransactionPresentationToDatasource = (datasource = []) => {
	let changed = false;
	const presentedDatasource = datasource.map(transaction => {
		const presentedTransaction = applyTransactionPresentation(transaction);
		if (presentedTransaction !== transaction) changed = true;
		return presentedTransaction;
	});

	return changed ? presentedDatasource : datasource;
};

const getSeriesStateChangeSnapshot = row =>
	parseProps(row?.props).seriesStateChange || {};

export const isSeriesStateChangeDetail = row =>
	Boolean(parseProps(row?.props).seriesStateChange);

export const getSeriesStateTransitionLabel = row => {
	const snapshot = getSeriesStateChangeSnapshot(row);
	const fromStateName =
		snapshot.fromStateName ??
		snapshot.previousStateName ??
		row?.fromStateName ??
		row?.previousStateName;
	const toStateName =
		snapshot.toStateName ??
		snapshot.targetStateName ??
		row?.toStateName ??
		row?.targetStateName ??
		row?.stateName ??
		row?.state_name;

	return fromStateName && toStateName
		? `${fromStateName} → ${toStateName}`
		: toStateName;
};

export const getSeriesStateDisplayLabel = (
	row,
	{ isSeriesStateChange = false } = {},
) => {
	const targetStateName = row?.stateName ?? row?.state_name;

	if (!isSeriesStateChange && !isSeriesStateChangeDetail(row))
		return targetStateName;

	return getSeriesStateTransitionLabel(row) ?? targetStateName;
};

export const applySeriesStateChangeDetailPresentation = row => {
	const stateLabel = getSeriesStateDisplayLabel(row, {
		isSeriesStateChange: true,
	});
	const presentedRow = {
		...row,
		action: SERIES_STATE_CHANGE_ACTION_LABEL,
		action_label: SERIES_STATE_CHANGE_ACTION_LABEL,
		actionLabel: SERIES_STATE_CHANGE_ACTION_LABEL,
		...(row?.stateName !== undefined && stateLabel
			? { stateName: stateLabel }
			: {}),
		...(row?.state_name !== undefined && stateLabel
			? { state_name: stateLabel }
			: {}),
	};

	return Object.keys(presentedRow).every(
		key => presentedRow[key] === row?.[key],
	)
		? row
		: presentedRow;
};

export const applySeriesStateChangePresentationToDatasource = (
	datasource = [],
	{ isSeriesStateChange = false } = {},
) => {
	let changed = false;
	const presentedDatasource = datasource.map(row => {
		if (!isSeriesStateChange && !isSeriesStateChangeDetail(row)) return row;

		const presentedRow = applySeriesStateChangeDetailPresentation(row);
		if (presentedRow !== row) changed = true;
		return presentedRow;
	});

	return changed ? presentedDatasource : datasource;
};
